var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPersonFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.5C6.16304 0.5 6.79893 0.763392 7.26777 1.23223C7.73661 1.70107 8 2.33696 8 3C8 3.66304 7.73661 4.29893 7.26777 4.76777C6.79893 5.23661 6.16304 5.5 5.5 5.5C4.83696 5.5 4.20107 5.23661 3.73223 4.76777C3.26339 4.29893 3 3.66304 3 3C3 2.33696 3.26339 1.70107 3.73223 1.23223C4.20107 0.763392 4.83696 0.5 5.5 0.5ZM5.5 6.75C8.2625 6.75 10.5 7.86875 10.5 9.25V10.5H0.5V9.25C0.5 7.86875 2.7375 6.75 5.5 6.75Z",
    fill: "black",
    fillOpacity: 0.66
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFill);
export default __webpack_public_path__ + "static/media/PersonFill.6e49a854.svg";
export { ForwardRef as ReactComponent };